<template>
	<el-dialog
		class="deducationVerifiDialog"
		:visible.sync="show"
		title="确认支付"
		:width="isChecked ? '530' : '620'"
		append-to-body
		@closed="closeDialog"
	>
		<div class="price_wrap" :class="{ isNeedCheck: !isChecked }">
			<div v-if="surplus" class="price_item surplus_price">
				<div class="label">余额抵扣金额</div>
				<div class="price_num">{{ (surplus / 100).toFixed(2) }}元</div>
			</div>
			<div v-if="charge" class="price_item surplus_price">
				<div class="label">手续费</div>
				<div class="price_num">{{ (charge / 100).toFixed(2) }}元</div>
			</div>
			<div class="price_item surplus_price">
				<div class="label">实际支付金额</div>
				<div class="price_num">{{ (amount / 100).toFixed(2) }}元</div>
			</div>
		</div>
		<p v-if="selfMchInfo.payMchName" class="tips" style="color: #f81919; margin-top: 20px">
			你已经接入独立商户{{ selfMchInfo.payMchName }}({{
				selfMchInfo.payMchId
			}}),请确保此商户号中运营账户的余额大于等于{{ (amount / 100).toFixed(2) }}元，否则观众领到的红包无法到账
		</p>
		<div v-if="!isChecked" class="check_wrap">
			<div v-if="surplus" class="tips">为了保障您的资金安全，使用余额抵扣支付将进行短信验证</div>
			<div class="infoItem">
				<div class="label">注册手机号</div>
				<div class="info">{{ adminMobile.substring(0, 3) }}****{{ adminMobile.substring(7, 11) }}</div>
			</div>
			<div class="infoItem input">
				<div class="label">验证码</div>
				<div class="info">
					<input ref="smsCodeInput" v-model="smsCode" type="text" />
					<el-button :disabled="disabledGetCode" @click="getCode">{{ getCodeText }}</el-button>
				</div>
			</div>
		</div>
		<div class="operate_wrap">
			<el-button class="cancel" @click="close">取消</el-button>
			<el-button class="enter" @click="enter">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { activity, errors, sms } from '@services';
export default {
	props: {
		money: {
			type: [String, Number],
			default: 100,
		},
	},
	data() {
		return {
			selfMchInfo: {},
			show: false,
			disabledGetCode: false,
			// disabledEnter: false,
			smsCode: '',
			resolve: null,
			reject: null,
			timer: null,
			seconds: 60,
			adminMobile: '',
			isChecked: true,
			surplus: 0,
			amount: 0,
			charge: 0,
			id: null,
		};
	},
	computed: {
		getCodeText() {
			return this.disabledGetCode ? this.seconds : '获取验证码';
		},
	},
	methods: {
		async getselfMchInfo(activityId) {
			const { ok, data } = await activity.selfMchInfo(activityId);
			if (ok) {
				this.selfMchInfo = data.data || {};
			}
		},
		closeDialog() {
			this.smsCode = '';
			this.surplus = 0;
			this.amount = 0;
			this.stop('用户主动取消');
		},
		checkSend(priceData) {
			if (!priceData) return;
			const activityId = priceData.id || this.$route.params.id;
			if (!activityId) return;
			this.amount = priceData.amount ? priceData.amount : 0;
			this.charge = priceData.charge ? priceData.charge : 0;
			this.surplus = priceData.surplus ? priceData.surplus : 0;
			this.id = priceData.id || null;
			return new Promise(async (resolve, reject) => {
				this.resolve = resolve;
				this.reject = reject;
				try {
					this.getselfMchInfo(activityId);
					const { ok, data } = await sms.checkSend({
						activityId,
					});
					if (ok) {
						// true,需要校验
						if (data.data.flag) {
							this.adminMobile = data.data.mobile;
							this.isChecked = false;
						} else {
							this.isChecked = true;
						}
						this.show = true;
					} else {
						this.stop(data.msg);
					}
				} catch (err) {
					errors(err);
					this.stop('验证是否需要验证码接口出错');
				}
			});
		},
		async getCode() {
			if (this.disabledGetCode) {
				return;
			}
			this.disabledGetCode = true;
			try {
				const { ok, data } = await sms.offsetSmsCode({
					mobile: this.adminMobile,
					areaCode: '+86',
					activityId: this.id || this.$route.params.id,
					money: Math.round(this.money * 100),
				});
				if (ok) {
					this.smsCode = data.data ? data.data : '';
					this.$message.success(data.msg);
					this.timerStart();
				}
			} catch (err) {
				errors(err);
			}
		},
		timerStart() {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				if (--this.seconds <= 0) {
					this.disabledGetCode = false;
					this.seconds = 60;
				}
			}, 1000);
		},
		enter() {
			if (this.isChecked) return this.next(false);
			// this.disabledEnter = true;
			if (this.smsCode) {
				this.next(true);
				this.show = false;
			} else {
				this.$message.error('请输入验证码');
				this.reInput();
			}
		},
		stop(info = '未知错误，流程终止') {
			this.resolve &&
				this.resolve({
					next: false,
					info,
				});
		},
		next(check) {
			this.resolve &&
				this.resolve({
					next: true, // 是否继续流程
					check, // 是否需要验证码
					smsCode: this.smsCode, // 验证码信息
				});
			this.close();
		},
		reInput() {
			// this.disabledEnter = false;
			this.smsCode = '';
			this.$refs.smsCodeInput.focus();
		},
		close() {
			this.show = false;
		},
	},
};
</script>

<style lang="less">
.deducationVerifiDialog {
	.el-dialog__header {
		padding-bottom: 15px;
		border-bottom: 1px solid #dddddd;
		.title {
			font-size: 18px;
		}
		.el-icon-close {
			color: #9098a8;
			font-size: 16px;
			margin-top: -4px;
			font-weight: 500;
		}
	}
	.el-dialog__body {
		padding: 24px 30px 60px;
		font-size: 16px;
	}
	.price_wrap {
		width: 100%;
		padding: 16px 20px;
		box-sizing: border-box;
		.price_item {
			width: 100%;
			display: flex;
			flex-flow: row nowrap;
			justify-content: space-between;
			align-items: center;
			color: #63666f;
			font-size: 14px;
			& + .price_item {
				margin-top: 24px;
			}
		}
		&.isNeedCheck {
			background-color: rgba(71, 125, 242, 0.03);
		}
	}
	.check_wrap {
		width: 100%;
		margin-top: 12px;
	}
	.infoItem {
		width: 100%;
		display: flex;
		height: 32px;
		flex-flow: row nowrap;
		align-items: center;
		margin-top: 12px;
		&.input {
			margin-top: 20px;
		}
		.label {
			width: 100px;
		}
		.info {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			input {
				width: 194px;
				-webkit-appearance: none;
				background-color: #fff;
				background-image: none;
				border-radius: 2px;
				border: 1px solid #dcdfe6;
				box-sizing: border-box;
				height: 32px;
				padding: 0 4px;
				outline: none;
			}
		}
	}
	.el-button {
		width: 90px;
		padding: 8px 10px;
		margin-left: 10px;
		border-color: #2c7dfa;
		color: #2c7dfa;
	}
	.el-button.is-disabled {
		color: #c0c4cc;
		border-color: #c0c4cc;
	}
	.cancel {
		margin-right: 40px;
	}
	.enter {
		width: 90px;
		margin-left: 0;
		background-color: #2c7dfa;
		color: #fff;
	}
	.operate_wrap {
		margin-top: 30px;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: flex-end;
		.label {
			width: 100%;
			flex-grow: 1;
		}
		.el-button {
			margin-left: 0;
		}
	}
}
</style>
